<template>
  <div class="home mt-2">
    <entity-header
      title="Integradores"
      :show-filters="true"
      :show-export="false"
      :show-new="true"
      new-label="Nuevo Integrador"
      new-tooltip="Nuevo Integrador"
      :show-status-filter="true"
      :status.sync="integrador_activo"
      :has-active-filters="hasActiveFilters"
      @status-change="getIntegradoresBusqueda"
      @search="getIntegradoresBusqueda"
      @new="showEdit({}, 'add')"
    >
      <template #filters>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="integrador_select_filter">Por Integrador</label>
          <select
            class="form-control"
            id="integrador_select_filter"
            v-model="integrador_sel"
            @change="changePage(1)"
            aria-label="Integrador"
          >
            <option value="">Todos los integradores</option>
            <template v-if="integradoresList && integradoresList.length">
              <option
                v-for="item in integradoresList"
                :key="item.id_integrador || item.id"
                :value="item.id_integrador || item.id"
              >
                {{ item.integrador }}
              </option>
            </template>
          </select>
        </div>
      </template>
    </entity-header>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <data-table
      v-if="integradoresBusqueda && integradoresBusqueda.data.length"
      :columns="columns"
      :data="integradoresBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_integrador"
      @sort="orderByfield"
    >
      <template #cell-ctr_events="{ item, value }">
        <div class="text-left" style="min-width: 140px;">
          <template v-if="!value || formatCtrEvents(value) === '-'">
            <span class="text-muted">-</span>
          </template>
          <template v-else>
            <span :title="formatCtrEvents(value)">
              {{ getTruncatedEvents(formatCtrEvents(value), 35) }}
            </span>
            <a
              v-if="shouldTruncateEvents(formatCtrEvents(value), 35)"
              href="#"
              class="ml-1 text-primary font-weight-bold"
              style="font-size: 0.8rem; cursor: pointer; white-space: nowrap; text-decoration: underline;"
              :title="formatCtrEvents(value)"
              @click.prevent="showTooltip($event, item, formatCtrEvents(value))"
            >
              ver más
            </a>
          </template>
        </div>
      </template>

      <template #actions="{ item }">
        <table-actions
          :item="item"
          active-key="activo"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador
      v-if="integradoresBusqueda && integradoresBusqueda.pages"
      :pages="integradoresBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <empty-state
      :show="Boolean(post && integradoresBusqueda && integradoresBusqueda.data && !integradoresBusqueda.data.length)"
      message="No se encontraron integradores que coincidan con la búsqueda."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal CRUD Estandarizado -->
    <crud-modal
      :show="showModal"
      :title="modalTitle"
      :is-toggle="operation == 'toggle'"
      :show-save="operation == 'edit' || operation == 'add' || operation == 'toggle'"
      :save-text="modalSaveText"
      :save-variant="operation == 'toggle' ? (editData && editData.activo == 1 ? 'warning' : 'success') : 'primary'"
      size="lg"
      @close="closeModal"
      @save="onModalSave"
    >
      <template #toggle-info>
        <div
          v-if="operation === 'toggle' && editData && (editData.activo == 1 || editData.activo == '1')"
          class="alert alert-info d-flex align-items-center mb-3"
          role="alert"
        >
          <i class="bi bi-info-circle-fill mr-2" style="font-size: 1.25rem;"></i>
          <div>
            <strong>Información:</strong> Esto implica que no se podrán dar nuevas altas sobre los servicios asociados, esto no afecta a las solicitudes de bajas.
          </div>
        </div>
      </template>

      <template #toggle-message>
        <div v-if="operation === 'toggle' && editData && (editData.activo == 1 || editData.activo == '1')">
          <strong>Advertencia:</strong> Al desactivar este integrador se desactivarán automáticamente los operadores, productos y servicios asociados.
        </div>
      </template>

      <form v-if="editData && (operation == 'edit' || operation == 'add')" @submit.prevent="onModalSave">
        <div class="form-group">
          <label class="font-weight-bold small text-muted mb-1">
            Integrador <span class="text-danger">*</span>
          </label>
          <input
            class="form-control"
            name="integrador"
            type="text"
            placeholder="Ej: Movistar, Claro, Entel"
            v-model="editData.integrador"
            required
          />
          <small class="form-text text-muted">Nombre del integrador asociado.</small>
        </div>

        <div class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Endpoint para CTRs</label>
          <input
            class="form-control"
            name="ctr_url"
            type="url"
            placeholder="Ej: https://midominio.com/api/ctr"
            v-model="editData.ctr_url"
          />
          <small class="form-text text-muted">URL o endpoint donde se enviarán las notificaciones de CTRs.</small>
        </div>

        <div class="form-group">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <label class="font-weight-bold small text-muted mb-0">Eventos de CTRs</label>
            <div>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm py-0 px-2 mr-1"
                style="font-size: 0.75rem;"
                @click="selectAllEvents"
              >
                Seleccionar todos
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm py-0 px-2"
                style="font-size: 0.75rem;"
                @click="clearAllEvents"
              >
                Limpiar
              </button>
            </div>
          </div>

          <small class="form-text text-muted mb-2">Seleccione los eventos CTR a notificar:</small>
          <div
            class="border rounded p-2"
            style="max-height: 180px; overflow-y: auto; overflow-x: hidden; background-color: #f8f9fa;"
          >
            <div class="row mx-0">
              <div
                class="col-sm-6 px-1 mb-2"
                v-for="evt in listaEventosCtr"
                :key="evt.id"
              >
                <div class="custom-control custom-checkbox text-truncate" :title="evt.label || evt.nombre">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="'evt_' + evt.id"
                    :value="evt.id"
                    v-model="editData.selectedEvents"
                  />
                  <label
                    class="custom-control-label"
                    :for="'evt_' + evt.id"
                    style="cursor: pointer; font-size: 0.85rem;"
                  >
                    {{ evt.label || evt.nombre }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <small class="form-text text-muted mt-1">
            {{ (editData.selectedEvents || []).length }} evento(s) seleccionado(s)
          </small>
        </div>

        <div v-if="errors" class="alert alert-danger" role="alert">
          {{ errors }}
        </div>
      </form>
    </crud-modal>

    <!-- Tooltip / Popover flotante para Eventos CTRs -->
    <div
      v-if="activeTooltip.visible"
      class="events-popover-tooltip shadow-lg border rounded p-2"
      :style="{
        position: 'fixed',
        top: activeTooltip.top + 'px',
        left: activeTooltip.left + 'px',
        zIndex: 1060,
        width: '320px',
        maxWidth: '90vw',
        backgroundColor: '#ffffff'
      }"
    >
      <div class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-2">
        <span class="font-weight-bold small text-dark">
          <i class="bi bi-info-circle-fill text-primary mr-1"></i>
          {{ activeTooltip.title }}
        </span>
        <button
          type="button"
          class="close"
          style="font-size: 1.1rem; line-height: 1; padding: 0 4px;"
          @click="closeTooltip"
        >
          &times;
        </button>
      </div>
      <div class="small text-secondary" style="max-height: 180px; overflow-y: auto; overflow-x: hidden; line-height: 1.4; word-break: break-word;">
        {{ activeTooltip.content }}
      </div>
    </div>
    <div
      v-if="activeTooltip.visible"
      class="tooltip-backdrop"
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 1055; background: transparent;"
      @click="closeTooltip"
    ></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import EntityHeader from "./utiles/EntityHeader.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import CrudModal from "./utiles/CrudModal.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { invalidateCatalog } from "@/utils/filterCache";

export default {
  name: "Integradores",
  mixins: [tableSortMixin],

  data() {
    return {
      columns: [
        { label: "Id", field: "id_integrador", width: "60" },
        { label: "Integrador", field: "integrador" },
        {
          label: "Endpoint CTRs",
          field: "ctr_url",
          formatter: (val, item) => val || (item && (item.ctr_url || item.endpoint_eventos || item.endpoint)) || "-"
        },
        {
          label: "Eventos CTRs",
          field: "ctr_events",
          formatter: (val, item) => this.formatCtrEvents(val || (item && item.ctr_events))
        },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      listaEventosCtr: [],
      activeTooltip: {
        visible: false,
        title: "",
        content: "",
        top: 0,
        left: 0,
        itemId: null
      },
      success: null,
      error: null,
      integrador_sel:
        localStorage.getItem("integrador") && localStorage.getItem("integrador") !== "todos"
          ? localStorage.getItem("integrador")
          : "",
      integrador_activo: 1,
      integradoresBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: null
    };
  },

  components: {
    EntityHeader,
    DataTable,
    Paginador,
    TableActions,
    EmptyState,
    CrudModal,
  },

  created() {
    this.fetchIntegradores();
    const stored = localStorage.getItem("integrador");
    if (stored && stored !== "todos") {
      this.integrador_sel = stored;
    }
    this.getEventosCtr();
    this.getIntegradoresBusqueda();
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    integradoresList() {
      let list = [];
      if (this.integradores && Array.isArray(this.integradores.data)) {
        list = [...this.integradores.data];
      } else if (Array.isArray(this.integradores)) {
        list = [...this.integradores];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
    modalTitle() {
      if (this.operation === "add") return "Nuevo Integrador";
      if (this.operation === "edit") {
        return `Editar Integrador ${this.editData ? this.editData.id_integrador : ""}`;
      }
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1
          ? "Suspender Integrador"
          : "Reactivar Integrador";
      }
      return "";
    },
    modalSaveText() {
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1 ? "Suspender" : "Reactivar";
      }
      return "Guardar";
    },
    hasActiveFilters() {
      return (
        (this.integrador_activo !== null && this.integrador_activo !== undefined) ||
        (Boolean(this.integrador_sel) && this.integrador_sel !== "todos")
      );
    },
  },
  methods: {
    ...mapActions("integrador", ["fetchIntegradores"]),
    onModalSave() {
      if (this.operation === "add") {
        this.agregarIntegrador();
      } else if (this.operation === "edit") {
        this.editIntegrador();
      } else if (this.operation === "toggle") {
        this.toggleStatus();
      }
    },
    changePage: function(page) {
      this.page = page;
      this.getIntegradoresBusqueda(false);
    },

    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getIntegradoresBusqueda(false);
    },
    getIntegradoresBusqueda: function(hideResult = true) {
      if (hideResult) this.integradoresBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      const sel =
        this.integrador_sel && this.integrador_sel !== "todos"
          ? this.integrador_sel
          : null;
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/busqueda", {
          page: this.page,
          id_integrador: sel,
          integrador: sel,
          activo: this.integrador_activo,
          order_by: { field: this.orderByField, order: this.orderByDirection }
        })
        .then(response => {
          this.integradoresBusqueda = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
   
    getEventosCtr: function() {
      axios
        .get(process.env.VUE_APP_API_URL + "integrador/eventos")
        .then(response => {
          if (response && response.data && response.data.data) {
            this.listaEventosCtr = response.data.data;
            if (
              this.operation === "add" &&
              this.editData &&
              (!this.editData.selectedEvents || !this.editData.selectedEvents.length)
            ) {
              this.$set(
                this.editData,
                "selectedEvents",
                this.listaEventosCtr.map(e => e.id)
              );
            }
          }
        })
        .catch(() => {
          this.listaEventosCtr = [];
        });
    },

    getEventName: function(id) {
      if (!this.listaEventosCtr || !this.listaEventosCtr.length) {
        return `Evento ${id}`;
      }
      const evt = this.listaEventosCtr.find(e => Number(e.id) === Number(id));
      return evt ? (evt.label || evt.nombre) : `Evento ${id}`;
    },

    formatCtrEvents: function(val) {
      if (!val) return "-";
      let ids = [];
      if (Array.isArray(val)) {
        ids = val.map(x => parseInt(x, 10)).filter(x => !isNaN(x));
      } else if (typeof val === "string") {
        ids = val.split(",").map(x => parseInt(x.trim(), 10)).filter(x => !isNaN(x));
      }
      if (!ids.length) return "-";
      return ids.map(id => this.getEventName(id)).join(", ");
    },

    showTooltip: function(event, item, fullText) {
      if (this.activeTooltip.visible && this.activeTooltip.itemId === item.id_integrador) {
        this.closeTooltip();
        return;
      }
      const rect = event.target.getBoundingClientRect();
      const tooltipWidth = 320;
      let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
      if (left < 15) left = 15;
      if (left + tooltipWidth > window.innerWidth - 15) {
        left = window.innerWidth - tooltipWidth - 15;
      }
      let top = rect.bottom + 6;
      if (top + 200 > window.innerHeight) {
        top = Math.max(10, rect.top - 180);
      }
      this.activeTooltip = {
        visible: true,
        title: item.integrador ? `Eventos CTRs (${item.integrador})` : "Eventos CTRs",
        content: fullText,
        top: Math.max(10, top),
        left: Math.max(10, left),
        itemId: item.id_integrador
      };
    },

    closeTooltip: function() {
      this.activeTooltip = {
        visible: false,
        title: "",
        content: "",
        top: 0,
        left: 0,
        itemId: null
      };
    },

    shouldTruncateEvents: function(text, maxLength = 45) {
      return Boolean(text && text.length > maxLength);
    },

    getTruncatedEvents: function(text, maxLength = 45) {
      if (!text || text.length <= maxLength) return text;
      return text.substring(0, maxLength).trimEnd() + "...";
    },

    selectAllEvents: function() {
      if (this.editData && this.listaEventosCtr) {
        this.$set(this.editData, "selectedEvents", this.listaEventosCtr.map(e => e.id));
      }
    },

    clearAllEvents: function() {
      if (this.editData) {
        this.$set(this.editData, "selectedEvents", []);
      }
    },

    editIntegrador: function() {
      this.errors = null;
      if (!this.editData || !this.editData.integrador || !this.editData.integrador.trim()) {
        this.errors = "El nombre del integrador es obligatorio y no puede estar en blanco.";
        return;
      }
      this.$store.commit("setLoading", true);
      const eventsStr = (this.editData.selectedEvents || []).slice().sort((a, b) => a - b).join(",");
      const payload = {
        ...this.editData,
        ctr_url: this.editData.ctr_url || "",
        ctr_events: eventsStr,
        endpoint_eventos: this.editData.ctr_url || "",
        endpoint: this.editData.ctr_url || "",
      };
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/update", payload)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            invalidateCatalog("integrador");
            this.fetchIntegradores(true);
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Integrador actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    toggleStatus: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      const targetActivo = 1 - Number(this.editData.activo || 0);
      const payload = {
        ...this.editData,
        activo: targetActivo,
      };
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/update", payload)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            invalidateCatalog("integrador");
            this.fetchIntegradores(true);
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Integrador actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
            Swal.fire({
              title: "Error!",
              text: e.response.data.error,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    showEdit: function(item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      const rawEvents = this.editData.ctr_events;
      let parsedEvents = [];
      if (Array.isArray(rawEvents)) {
        parsedEvents = rawEvents.map(x => parseInt(x, 10)).filter(x => !isNaN(x));
      } else if (rawEvents && typeof rawEvents === "string") {
        parsedEvents = rawEvents.split(",").map(x => parseInt(x.trim(), 10)).filter(x => !isNaN(x));
      }
      this.$set(this.editData, "selectedEvents", parsedEvents);
      this.$set(this.editData, "ctr_url", this.editData.ctr_url || this.editData.endpoint_eventos || this.editData.endpoint || "");

      if (operation === "add") {
        if (!this.editData.integrador) this.editData.integrador = "";
        this.editData.ctr_url = "";
        const allEventIds =
          this.listaEventosCtr && this.listaEventosCtr.length
            ? this.listaEventosCtr.map(e => e.id)
            : [];
        this.$set(this.editData, "selectedEvents", allEventIds);
      }
      this.showModal = true;
      this.operation = operation;
    },

    agregarIntegrador: function() {
      this.errors = null;
      if (!this.editData || !this.editData.integrador || !this.editData.integrador.trim()) {
        this.errors = "El nombre del integrador es obligatorio y no puede estar en blanco.";
        return;
      }
      this.$store.commit("setLoading", true);
      const eventsStr = (this.editData.selectedEvents || []).slice().sort((a, b) => a - b).join(",");
      const payload = {
        ...this.editData,
        ctr_url: this.editData.ctr_url || "",
        ctr_events: eventsStr,
        endpoint_eventos: this.editData.ctr_url || "",
        endpoint: this.editData.ctr_url || "",
      };
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/new", payload)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            invalidateCatalog("integrador");
            this.fetchIntegradores(true);
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Integrador creado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
      this.editData = null;
      this.errors = null;
    }
  }
};
</script>

<style scoped></style>
